<script setup>
// The line a Donate or Shop block shows when Stripe sends the visitor
// back: thanks after a payment, or a plain sentence when the checkout
// could not be opened at all. Read once on mount; the block it sits in
// passes its own kind, so a page with both blocks thanks the right one.
import { inject, onMounted, ref } from 'vue';
import { checkoutReturn } from './useSiteForm.js';

const props = defineProps({
    kind: { type: String, required: true },
});

const editing = inject('tiqEditorCanvas', false);
const text = ref('');
const tone = ref('ok');

onMounted(() => {
    if (editing) return;
    const r = checkoutReturn();
    if (r.paid === props.kind) {
        tone.value = 'ok';
        text.value = props.kind === 'shop'
            ? 'Thank you for your order.'
            : 'Thank you for your gift.';
    } else if (r.unavailable && props.kind === 'shop') {
        tone.value = 'bad';
        text.value = `“${r.unavailable}” can no longer be bought here, or not in the size in your cart. Remove it from your cart and try again. Nothing was charged.`;
    } else if (r.failed && !r.paid) {
        tone.value = 'bad';
        text.value = 'The card checkout could not be opened just now. Nothing was charged. Please try again in a moment.';
    }
});
</script>

<template>
    <p v-if="text" class="tiq-checkout-notice" :class="`is-${tone}`" role="status">{{ text }}</p>
</template>

<style scoped>
.tiq-checkout-notice {
    margin: 0 0 16px;
    padding: 10px 14px;
    border-radius: 8px;
    font-size: 15px;
    line-height: 1.4;
}
.tiq-checkout-notice.is-ok { background: #ecfdf5; color: #065f46; border: 1px solid #a7f3d0; }
.tiq-checkout-notice.is-bad { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }
</style>
